<template>
    <div class="login1">
        <div class="boton_l" @click="$emit('close-login')">
            <svg style="color: white;" class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </div>
        <div class="logo">
            <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo">
            <span>Ingrese su usuario y contraseña para empezar a jugar</span>
        </div>
        <form @submit.prevent="login()">
            <div style="display:flex;justify-content:center;">
                <input v-model="username" class="input_class" type="text" :placeholder="translate('user')">
            </div>
            <div v-if="!resetPassword" style="display:flex;justify-content:center;">
                <input style="margin: 20px 0px;" v-model="password" id="password" type="password" class="input_class"
                    :placeholder="translate('password')">
            </div>
            <div class="d-flex mb-3 align-content-center justify-content-center">
                <button id="submit_btn" type="submit" class="btn p-2 login-btn"
                    :style="{ 'background-image': skin.main_active_1, 'color': skin.header_desktop.nav_bar_item_hover_color }"
                    style="color:black;width: 90%;" :disabled="login_inProcess">{{ translate('log_in') }}</button>
            </div>
        </form>
        <div v-if="status.message!=''" :class="'alert alert-'+status.type" role="alert">{{ status.message }}</div>

    </div>
</template>
<script>
export default {
    name: "login",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            username: "",
            password: "",
            resetPassword: false,
            status: {
                message: "",
                type: ""
            },
            login_inProcess: false
        }
    },
    methods: {
        async login(){
            this.login_inProcess = true;
            if(this.resetPassword){
                if(this.username!=""){
                    let reset = await axios.post(this.$store.getters["getDomain"]+"/swarm/remote/forgot_password",{
                        "email":this.username
                    })
                    if(reset.data.success){
                        this.status.message=reset.data.message;
                        this.status.type="success";
                    }
                    else{
                        this.status.message=reset.data.message;
                        this.status.type="danger";
                    }
                    this.resetPassword = false;
                }
                else{
                    this.status.message=this.translate("input_email");
                    this.status.type="danger"; 
                }
                this.login_inProcess = false;
            }
            else{
                let data = await this.$store.dispatch('login',{username:this.username,password:this.password});
                if(data=="success"){
                    console.log(data);
                    this.$emit('close-login');
                    this.login_inProcess = false;
                    this.username = '';
                    this.password = '';
                    this.status.message = '';
                }
                else{
                    this.status.message=data;
                    this.status.type="danger";
                    this.login_inProcess = false;
                }
            }
            
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@500&display=swap');

.login1 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;
    max-width: 577px;
    margin: 4px;
    width: 100%;
    height: 75%;
    box-shadow: 0 5px 60px #021b79;
    border-radius: 10px;
}

.boton_l {
    position: absolute;
    top: 20px;
    right: 20px;
    max-width: 32px;
    width: 100%;
    max-height: 32px;
    height: 100%;
}

.logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    width: 90%;
}

.logo img {
    max-width: 80%;
    height: 100%;
    /* Asegura que la imagen no se desborde horizontalmente */
    max-height: 100%;
    /* Asegura que la imagen no se desborde verticalmente */
    object-fit: contain;
    /* Ajusta la imagen dentro del contenedor sin distorsión */
}

.logo span {
    color: white;
    font-family: "Open Sans";
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    cursor: pointer;
    text-align: center;
}

.input_class {
    width: 90%;
    font-size: 16px;
    margin-top: 40px;
    padding: 8px 220px 8px 10px;
    color: white;
    background-color: #212c36;
    border-radius: 5px;
    border-style: solid;
    box-sizing: border-box;
    border-width: 1px;
    border-color: #4b5563;
}
@media (max-width: 767px) {
    .login1 {
        max-width: 350px;
    }
}
</style>